import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MotMonthViewAnnualGridComponent } from '@app/activo2/vacations/components/mot-month-view-annual-grid/mot-month-view-annual-grid.component';
import { MotYearComponent } from '@app/activo2/vacations/components/mot-year/mot-year.component';
import { TotalVacationsComponent } from '@app/activo2/vacations/components/total-vacations/total-vacations.component';
import { TotalVacationsDetailModalComponent } from '@app/activo2/vacations/components/total-vacations-detail-modal/total-vacations-detail-modal.component';
import { TotalVacationsElementComponent } from '@app/activo2/vacations/components/total-vacations-element/total-vacations-element.component';
import { VacationToolsComponent } from '@app/activo2/vacations/components/vacation-tools/vacation-tools.component';
import { ContentModule } from '@app/components/content/content.module';
import { HeaderModule } from '@app/components/header/header.module';
import { MenuModule } from '@app/components/menu/menu.module';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { ComponentsModule } from '@components/components.module';
import { IonicModule } from '@ionic/angular';
import { MotComponentsModule } from '@mot/components/mot-components.module';
import { ScheduleComponentsModule } from '@mot/schedule/components/schedule-components.module';
import { TranslateModule } from '@ngx-translate/core';

import { SignedVacationsItemComponent } from './signed-vacations/signed-vacations-list/signed-vacations-item/signed-vacations-item.component';
import { SignedVacationsListComponent } from './signed-vacations/signed-vacations-list/signed-vacations-list.component';
import { SignedVacationsComponent } from './signed-vacations/signed-vacations.component';
import { TotalVacationsDetailComponent } from './total-vacations-detail/total-vacations-detail.component';
import { TotalVacationsDetailPageComponent } from './total-vacations-detail-page/total-vacations-detail-page.component';

const components = [
  MotYearComponent,
  TotalVacationsComponent,
  MotMonthViewAnnualGridComponent,
  TotalVacationsElementComponent,
  TotalVacationsDetailModalComponent,
  TotalVacationsDetailComponent,
  TotalVacationsDetailPageComponent,
  VacationToolsComponent,
  SignedVacationsComponent,
  SignedVacationsListComponent,
  SignedVacationsItemComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    MenuModule,
    HeaderModule,
    ContentModule,
    TranslateModule.forChild(),
    ComponentsModule,
    MotComponentsModule,
    ScheduleComponentsModule,
    DirectivesModule
  ],
  declarations: components,
  entryComponents: [TotalVacationsDetailModalComponent],
  exports: components
})
export class VacationsComponentsModule {}
